import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template159: Le Marais (calles, Place des Vosges, Pompidou). Todo desde backend.
// page.texts[0]=header, [1]=intro (puede ser HTML), [2]=título portada | page.sections[0..3] (imageId, title, body, sabiasQue[0]; section1 box con imagen float desde canvas) | page.images, page.canvasImages (logo, marais-sticker, vosges-sticker)
const Template159 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const portadaTitle = page?.texts?.[2]?.content;
	const logoImage = getCanvasImageUrl("logo");

	const portadaImage = getImageSrc("portada");
	const maraisSticker = getCanvasImageUrl("marais-sticker");
	const vosgesSticker = getCanvasImageUrl("vosges-sticker");

	const sections = Array.isArray(page?.sections) ? page.sections : [];
	const section0 = sections[0];
	const section1 = sections[1];
	const section2 = sections[2];
	const section3 = sections[3];

	const vosgesImage = getImageSrc(section0?.imageId);
	const pompidouImage = getImageSrc(section2?.imageId);

	const actualHeaderColor = headerBackgroundColor || "#2C3E50";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{!isSmallScreen && logoImage && (
						<img
							src={logoImage}
							alt=""
							style={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<img
						src={portadaImage}
						alt=""
						style={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaTitle && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{portadaTitle}
						</Box>
					)}
					{maraisSticker && (
						<img
							src={maraisSticker}
							alt=""
							style={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: 60,
								left: isSmallScreen ? 15 : 20,
							}}
						/>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", paddingTop: 0, position: "relative" }}>
				{introText && (
					<Box
						component="div"
						dangerouslySetInnerHTML={{ __html: introText }}
						sx={{
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
							marginTop: "-10px",
						}}
					/>
				)}

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "10px",
						marginTop: "10px",
					}}
				>
					{section0 && (
						<Box data-block-id="text-2" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{vosgesImage && (
								<img
									src={vosgesImage}
									alt=""
									style={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: 12,
									}}
								/>
							)}
							<Box sx={{ width: vosgesImage ? "60%" : "100%" }}>
								{section0.title && (
									<Box component="h3" sx={estiloH3}>
										{section0.title}
									</Box>
								)}
								{section0.body && (
									<Box component="p" sx={estiloP}>
										{section0.body}
									</Box>
								)}
							</Box>
							{section0.sabiasQue?.[0] && (
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue
										icono={section0.sabiasQue[0].icono}
										texto={section0.sabiasQue[0].texto}
									/>
								</Box>
							)}
						</Box>
					)}

					{section1 && (
						<Box data-block-id="text-3" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							<Box sx={{ width: "100%" }}>
								<Box
									component="p"
									sx={{
										...estiloP,
										padding: "12px",
										backgroundColor: "#E8F4F8",
										borderRadius: "12px",
									}}
								>
									{vosgesSticker && (
										<img
											src={vosgesSticker}
											alt=""
											style={{
												width: isSmallScreen ? 105 : 115,
												float: "right",
												marginRight: -34,
												marginTop: -30,
												borderRadius: 12,
											}}
										/>
									)}
									{section1.title && (
										<Box component="h3" sx={estiloH3}>
											{section1.title}
										</Box>
									)}
									{section1.body}
								</Box>
							</Box>
						</Box>
					)}

					{section2 && (
						<Box data-block-id="text-4" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{pompidouImage && (
								<img
									src={pompidouImage}
									alt=""
									style={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: 12,
									}}
								/>
							)}
							<Box sx={{ width: pompidouImage ? "60%" : "100%" }}>
								{section2.title && (
									<Box component="h3" sx={estiloH3}>
										{section2.title}
									</Box>
								)}
								{section2.body && (
									<Box component="p" sx={estiloP}>
										{section2.body}
									</Box>
								)}
							</Box>
							{section2.sabiasQue?.[0] && (
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue
										icono={section2.sabiasQue[0].icono}
										texto={section2.sabiasQue[0].texto}
									/>
								</Box>
							)}
						</Box>
					)}

					{section3?.body && (
						<Box data-block-id="text-5" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							<Box sx={{ width: "100%" }}>
								<Box
									component="p"
									sx={{
										...estiloP,
										padding: "8px",
										backgroundColor: "#E8F4F8",
										borderRadius: "12px",
									}}
								>
									{section3.body}
								</Box>
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template159.thumbnail = "/images/template-1.png";

export default Template159;
